module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_8023.1a793738.png";